import { useState } from 'react';
import { Gift, Plus } from 'lucide-react';
import { Card, CardHeader } from '@/components/ui/Card';
import { Input } from '@/components/ui/Input';
import { Button } from '@/components/ui/Button';
import { EmptyState } from '@/components/ui/EmptyState';
import { ModuleTogglePanel } from '@/components/dashboard/ModuleTogglePanel';

export function GiveawaysPage() {
  const [prize, setPrize] = useState('');
  const [duration, setDuration] = useState('1h');

  return (
    <div className="space-y-6">
      <ModuleTogglePanel module="giveaways" title="Giveaways" permissionNote="Manage Server permission required." />

      <Card>
        <CardHeader title="Start a giveaway" description="Real fields from the bot's own /gstart command — role requirement and blacklist are both genuinely supported in v18. Starting one isn't connected yet — that needs a Bridge write path beyond this pass's enable/disable toggle above." />
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-3">
          <div>
            <label className="text-small text-text-secondary block mb-1">Prize</label>
            <Input value={prize} onChange={(e) => setPrize(e.target.value)} placeholder="Nitro Classic" />
          </div>
          <div>
            <label className="text-small text-text-secondary block mb-1">Duration</label>
            <Input value={duration} onChange={(e) => setDuration(e.target.value)} placeholder="1h" />
          </div>
          <div>
            <label className="text-small text-text-secondary block mb-1">Required role (optional)</label>
            <Input placeholder="@Members" disabled />
          </div>
          <div>
            <label className="text-small text-text-secondary block mb-1">Blacklisted role (optional)</label>
            <Input placeholder="@Muted" disabled />
          </div>
        </div>
        <Button variant="primary" disabled>
          <Plus size={16} aria-hidden="true" />
          Start giveaway
        </Button>
      </Card>

      <Card>
        <CardHeader title="Active giveaways" />
        <EmptyState icon={Gift} title="No active giveaways" />
      </Card>
    </div>
  );
}
